import React, {useMemo, useState} from "react";
import {Routes, Route, useLocation} from "react-router-dom";
import CancelConfirmation from "./CancelConfirmation";
import GetBooking from "../shared/GetBooking";
import InterfaceBooking from "../../interface/InterfaceBooking";
import EMPTY_BOOKING from "../../helpers/EmptyBooking";
import {SVVLayoutBanner, SVVLayoutPageType, SVVLayoutPageWrapper} from "@komponentkassen/svv-layout";
import {useApptekster} from "../../apptekst-context";
import {SVVHeading} from "@komponentkassen/svv-text";


const Cancel = () => {
  const [booking, setBooking] = useState<InterfaceBooking>(EMPTY_BOOKING);
  const [unreserved, setUnreserved] = useState<boolean>(false);
  const location = useLocation();
  const t = useApptekster();
  
  const {bannerIngress} = useMemo(() => {
    let bannerIngress = t("timebestilling.avbestill.hent-time-overskrift")

    if (location?.pathname) {
      if (location.pathname === '/avbestill/bekreftelse') {
        bannerIngress = t("timebestilling.avbestill.bekreftelse-ingress")
      }
    }
    return {
      bannerIngress
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <>
      <SVVLayoutBanner 
        medium
        noPaddingTop
      >
        <SVVHeading level="h1">
          {t("timebestilling.handling.avbestill")}
        </SVVHeading>
        <p className="svv-ingress">
          {bannerIngress}
        </p>
      </SVVLayoutBanner>
      <SVVLayoutPageWrapper>
        <SVVLayoutPageType medium>
          <div className="form-layout__main">
            <Routes>
              <Route
                path="avbestilltime"
                element={
                  <>
                    <GetBooking
                        isRebook={false}
                        setBooking={setBooking}
                    />
                  </>
                }
              />
              <Route
                path="bekreftelse"
                element={
                  <>
                    <CancelConfirmation
                        booking={booking}
                        setUnreserved={setUnreserved}
                        unreserved={unreserved}
                    />
                  </>
                }
              />
            </Routes>
          </div>
        </SVVLayoutPageType>
      </SVVLayoutPageWrapper>
    </>
  );
};

export default Cancel;
